import React from "react";

const Contact = () => {
  return (
    <div>
      <h1>Contact</h1>
      <p>
        <strong>Request an Appointment:</strong> You may call our Clermont
        or Davenport office Monday–Friday 8-5 to make an appointment.
        <br />
        <br />
        <strong>Phone #1:</strong> (352) 240-3812<br />
        <strong>Phone #2:</strong> (863) 226-4676<br />
        <strong>Email:</strong> akccf@kidneycarecentralflorida.com<br />
        <strong>Fax:</strong> (888) 716-2003
        <br />
        <br />
      </p>
    </div>
  );
};

export default Contact;
